const { name, version } = require("./version.json");
module.exports = { name, version };
